import bannerPrice20Pl from "assets/images/banners/banners-price/banner-price-20-pl.png";
import bannerPrice20Eng from "assets/images/banners/banners-price/banner-price-20-eng.png";
import bannerPrice20De from "assets/images/banners/banners-price/banner-price-20-de.png";

import bannerPrice25Pl from "assets/images/banners/banners-price/banner-price-25-pl.png";
import bannerPrice25Eng from "assets/images/banners/banners-price/banner-price-25-en.png";
import bannerPrice25De from "assets/images/banners/banners-price/banner-price-25-de.png";

import bannerPrice35Pl from "assets/images/banners/banners-price/banner-price-35-pl.png";
import bannerPrice35Eng from "assets/images/banners/banners-price/banner-price-35-eng.png";
import bannerPrice35De from "assets/images/banners/banners-price/banner-price-35-de.png";

import bannerVoucherPl from "assets/images/banners/banners-vouchers/banner-voucher-pl.png";

import bannerPixelBoxPl from "assets/images/banners/banners-pixel-box/banner-pixel-box-pl-v2.png";
import bannerPixelBoxEng from "assets/images/banners/banners-pixel-box/banner-pixel-box-eng-v2.png";
import bannerPixelBoxDe from "assets/images/banners/banners-pixel-box/banner-pixel-box-de-v2.png";

import bannerSeasonalPl from "assets/images/banners/banners-seasonal/banner-new-season-pl-v3.png";
import bannerSeasonalEng from "assets/images/banners/banners-seasonal/banner-new-season-eng-v3.png";
import bannerSeasonalDe from "assets/images/banners/banners-seasonal/banner-new-season-de-v3.png";

import bannerSummerPl from "assets/images/banners/banners-seasonal/banner-summer-pl.png";
import bannerSummerEng from "assets/images/banners/banners-seasonal/banner-summer-eng.png";
import bannerSummerDe from "assets/images/banners/banners-seasonal/banner-summer-de.png";

import bannerDiscountPl from "assets/images/banners/banners-discount/banner-50-discount-pl.png";
import bannerDiscountEng from "assets/images/banners/banners-discount/banner-50-discount-eng.png";
import bannerDiscountDe from "assets/images/banners/banners-discount/banner-50-discount-de.png";

import bannerStudentDiscountPl from "assets/images/banners/banners-discount/banner-studentpxl-discount-pl-v3.png";
import bannerStudentDiscountEng from "assets/images/banners/banners-discount/banner-studentpxl-discount-eng-v3.png";
import bannerStudentDiscountDe from "assets/images/banners/banners-discount/banner-studentpxl-discount-de.png";

import bannerStudia30DiscountPl from "assets/images/banners/banners-discount/banner-studia30-discount-pl-v3.png";
import bannerStudia30DiscountEng from "assets/images/banners/banners-discount/banner-studia30-discount-eng-v3.png";
import bannerStudia30DiscountDe from "assets/images/banners/banners-discount/banner-studia30-discount-de.png";

export const bannersImports = {
  price: {
    20: { pl: bannerPrice20Pl, eng: bannerPrice20Eng, de: bannerPrice20De },
    25: { pl: bannerPrice25Pl, eng: bannerPrice25Eng, de: bannerPrice25De },
    35: { pl: bannerPrice35Pl, eng: bannerPrice35Eng, de: bannerPrice35De },
  },
  voucher: { pl: bannerVoucherPl, eng: bannerVoucherPl, de: bannerVoucherPl },
  pixelBox: {
    pl: bannerPixelBoxPl,
    eng: bannerPixelBoxEng,
    de: bannerPixelBoxDe,
  },
  seasonal: {
    pl: bannerSeasonalPl,
    eng: bannerSeasonalEng,
    de: bannerSeasonalDe,
  },
  summer: {
    pl: bannerSummerPl,
    eng: bannerSummerEng,
    de: bannerSummerDe,
  },
  discount: {
    pl: bannerDiscountPl,
    eng: bannerDiscountEng,
    de: bannerDiscountDe,
  },
  studia30: {
    pl: bannerStudia30DiscountPl,
    eng: bannerStudia30DiscountEng,
    de: bannerStudia30DiscountDe,
  },
  studentpxl: {
    pl: bannerStudentDiscountPl,
    eng: bannerStudentDiscountEng,
    de: bannerStudentDiscountDe,
  },
};
